import styled from 'styled-components';
import { DarkSection, Colors, fonts } from '../style/GlobalStyles';

const Inner = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 5rem 2rem;

  @media (max-width: 868px) {
    padding: 3rem 1.25rem;
  }
`;

const Label = styled.span`
  display: inline-block;
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 0.95rem;
  color: ${Colors.paper};
  padding: 0.55rem 1.4rem;
  border: 1.5px solid rgba(242, 239, 230, 0.5);
  border-radius: 999px;
  margin-bottom: 3rem;
`;

const Grid = styled.div`
  display: flex;
  gap: 3.5rem;
  align-items: flex-start;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const PhotoBlock = styled.div`
  flex: 0 0 320px;
  aspect-ratio: 4 / 4.6;
  background: ${Colors.lime};
  border-radius: 20px;
  overflow: hidden;

  @media (max-width: 900px) {
    flex: 0 0 auto;
    width: 100%;
    max-width: 320px;
  }
`;

const Photo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
`;

const Content = styled.div`
  flex: 1;
`;

const Title = styled.h2`
  font-family: ${fonts.display};
  font-weight: 400;
  text-transform: uppercase;
  line-height: 0.95;
  color: ${Colors.paper};
  font-size: clamp(2.2rem, 5.5vw, 4.4rem);
  margin: 0 0 1.5rem 0;
`;

const Paragraph = styled.p`
  font-family: ${fonts.body};
  color: rgba(242, 239, 230, 0.78);
  font-size: 1.05rem;
  line-height: 1.75;
  max-width: 620px;
  margin: 0 0 2.5rem 0;

  b {
    color: ${Colors.lime};
    font-weight: 600;
  }
`;

const KeyHead = styled.h4`
  font-family: ${fonts.body};
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.85rem;
  color: rgba(242, 239, 230, 0.55);
  margin: 0 0 1rem 0;
`;

const KeyList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.7rem 2rem;

  li {
    font-family: ${fonts.body};
    color: ${Colors.paper};
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 0.7rem;
  }

  .dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${Colors.lime};
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const Footer = styled.div`
  display: flex;
  gap: 3rem;
  margin-top: 3rem;
  font-family: ${fonts.body};
  font-size: 0.95rem;
  color: rgba(242, 239, 230, 0.7);

  span {
    color: rgba(242, 239, 230, 0.45);
    margin-right: 0.6rem;
  }

  @media (max-width: 560px) {
    flex-direction: column;
    gap: 0.6rem;
  }
`;

const keySkills = [
  'Cloud architecture',
  'Backend & APIs',
  'Frontend (React / Vue)',
  'UI/UX & Figma',
  'Mobile (Flutter)',
  'Team leadership',
];

const AboutMe = () => {
  return (
    <DarkSection>
      <Inner>
        <Label className="gsap-fade-up">About Me</Label>
        <Grid>
          <PhotoBlock className="gsap-fade-up">
            <Photo src="/img/profilephoto.png" alt="Santiago Estrada" />
          </PhotoBlock>
          <Content>
            <Title className="gsap-fade-up">
              Who am I and
              <br />
              how can I help?
            </Title>
            <Paragraph className="gsap-fade-up">
              I'm Santiago, a <b>systems engineer</b> focused on building
              scalable cloud solutions and intuitive interfaces. I combine{' '}
              <b>backend architecture</b>, API development and{' '}
              <b>team leadership</b> to ship technology that's usable, reliable
              and built to last — from automating processes to optimizing
              deployments.
            </Paragraph>
            <KeyHead className="gsap-fade-up">Key skills</KeyHead>
            <KeyList className="gsap-fade-up">
              {keySkills.map((k) => (
                <li key={k}>
                  <span className="dot" />
                  {k}
                </li>
              ))}
            </KeyList>
            <Footer className="gsap-fade-up">
              <div>
                <span>Email</span>santiagoestrada.dev@gmail.com
              </div>
              <div>
                <span>Phone</span>+57 301 521 9172
              </div>
            </Footer>
          </Content>
        </Grid>
      </Inner>
    </DarkSection>
  );
};

export default AboutMe;
